(() => {
  const DISCOUNT_CODE = 'SZ-FLYX-PKG-ADJ-5H8M3T7';
  const DISCOUNT_TITLE = 'SportsZone FLY-X Package Adjustment';
  const LEGACY_CODES = new Set([
    'SZ-FLYX80-7K4M2',
    'SZ-FLYX-RUNNER-PKG-9Q7K4N2',
  ]);
  const LEGACY_TITLES = new Set([
    'SPORTSZONE FLY-X $80 PACKAGE SAVINGS',
    'SPORTSZONE FLY-X PACKAGE RUNNER',
  ]);
  const ELIGIBLE_SKATE_IDS = new Set([
    15242199433580,
    15242199466348,
    15242199499116,
    15242199531884,
    15242360258924,
    15242360652140,
    15242360684908,
    15242360717676,
    15245454475628,
    15242326507884,
    15242326704492,
    15242326475116,
    15242326671724,
  ]);
  const SAVINGS_CENTS = 8000;
  const SOURCE = 'sportszone-flyx-savings';
  const CARD_SELECTOR = '[data-sz-steel-choice]';
  let discountSyncPromise = null;

  const numericId = (value) => {
    const match = String(value || '').match(/(\d+)$/);
    return match ? Number(match[1]) : 0;
  };

  const money = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'CAD';
    const locale = document.documentElement.lang || 'en-CA';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
    } catch (_error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const rootUrl = () => window.Shopify?.routes?.root || '/';

  const parseJson = (node) => {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_error) {
      return [];
    }
  };

  const getSelectedSkateVariant = (root, card) => {
    const id = numericId(root?.querySelector('product-form form input[name="id"]')?.value);
    if (!id) return null;
    return parseJson(card.querySelector('[data-sz-skate-variants]'))
      .find((variant) => numericId(variant.id) === id) || null;
  };

  const getPriceBlock = (root) =>
    root?.querySelector('[id^="price-"]') ||
    root?.querySelector('.product__info-container .price')?.parentElement ||
    null;

  const ensurePriceNote = (root, priceBlock) => {
    let note = root.querySelector('[data-sz-flyx-main-price-note]');
    if (!note && priceBlock) {
      note = document.createElement('p');
      note.className = 'sz-flyx-main-price-note';
      note.dataset.szFlyxMainPriceNote = '';
      note.hidden = true;
      priceBlock.insertAdjacentElement('afterend', note);
    }
    return note;
  };

  const syncMainPrice = (root, baseCents, isFlyX, isSale) => {
    const priceBlock = getPriceBlock(root);
    if (!priceBlock) return;

    const note = ensurePriceNote(root, priceBlock);
    priceBlock.classList.toggle('sz-flyx-main-price', Boolean(isFlyX && !isSale));

    if (isSale || !baseCents) {
      if (note) note.hidden = true;
      return;
    }

    const priceNode =
      priceBlock.querySelector('.price__regular .price-item--regular') ||
      priceBlock.querySelector('.price-item--regular');

    if (priceNode) {
      priceNode.textContent = money(isFlyX ? Math.max(0, baseCents - SAVINGS_CENTS) : baseCents);
    }

    if (note) {
      note.hidden = !isFlyX;
      if (isFlyX) note.textContent = 'FLY-X package price · $80.00 net savings applied in cart';
    }
  };

  const ensureUi = (card) => {
    const xOption = card.querySelector('[data-sz-steel-option="FLY-X"]');
    const xCopy = xOption?.querySelector('.sz-steel-option__copy');
    if (xCopy && !xCopy.querySelector('[data-sz-flyx-save-badge]')) {
      const badge = document.createElement('span');
      badge.className = 'sz-flyx-save-badge';
      badge.dataset.szFlyxSaveBadge = '';
      badge.textContent = 'SAVE $80.00';
      xCopy.prepend(badge);
    }

    let summary = card.querySelector('[data-sz-flyx-summary]');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'sz-flyx-summary';
      summary.dataset.szFlyxSummary = '';
      summary.setAttribute('aria-live', 'polite');
      const options = card.querySelector('.sz-steel-choice__options');
      options?.insertAdjacentElement('afterend', summary);
    }
    return summary;
  };

  const syncUi = (root) => {
    const card = root?.querySelector(CARD_SELECTOR);
    if (!card) return;

    const summary = ensureUi(card);
    const isSale = card.dataset.szSaleState === 'true' || card.classList.contains('is-boot-only-sale');
    const selectedSteel = card.querySelector('[data-sz-steel-input]:checked')?.value || '';
    const xPrice = card.querySelector('[data-sz-steel-price="FLY-X"]');
    const intro = card.querySelector('[data-sz-steel-intro]');
    const variant = getSelectedSkateVariant(root, card);
    const baseCents = Number(variant?.price || 0);

    if (isSale) {
      root.classList.remove('sz-steel-flyx');
      syncMainPrice(root, baseCents, false, true);
      if (summary) summary.hidden = true;
      return;
    }

    if (intro) {
      intro.textContent = 'FLY-TI is the standard package. Choose FLY-X and your package total is $80.00 less. The exact FLY-X runner is added to the order so its inventory is tracked.';
    }
    if (xPrice) xPrice.textContent = 'SAVE $80.00';

    const flyXCents = Math.max(0, baseCents - SAVINGS_CENTS);
    const isFlyX = selectedSteel === 'FLY-X';
    root.classList.toggle('sz-steel-flyx', isFlyX);
    syncMainPrice(root, baseCents, isFlyX, false);

    if (!summary) return;
    summary.hidden = false;

    if (!baseCents) {
      summary.innerHTML = isFlyX
        ? '<strong>FLY-X selected</strong><span>Your package total will be $80.00 less in cart, with the matched runner tracked as a real inventory item.</span>'
        : '<strong>FLY-TI package selected</strong><span>Switch to FLY-X to save $80.00.</span>';
      return;
    }

    summary.innerHTML = isFlyX
      ? `<span class="sz-flyx-summary__eyebrow">FLY-X PACKAGE PRICE</span><strong>${money(flyXCents)}</strong><span>Net savings: $80.00. The matched FLY-X runner is included as a real order line for accurate inventory.</span>`
      : `<span class="sz-flyx-summary__eyebrow">FLY-TI PACKAGE PRICE</span><strong>${money(baseCents)}</strong><span>Choose FLY-X and pay ${money(flyXCents)} instead, saving $80.00.</span>`;
  };

  const scheduleUiSync = (root) => {
    if (!root?.querySelector(CARD_SELECTOR)) return;
    window.requestAnimationFrame(() => syncUi(root));
    window.setTimeout(() => syncUi(root), 120);
    window.setTimeout(() => syncUi(root), 260);
  };

  const collectDiscountName = (set, application) => {
    if (!application) return;
    const type = String(application.type || '').toLowerCase();
    if (type && type !== 'discount_code') return;
    const value = application.code || application.title;
    if (value) set.add(String(value));
  };

  const discountCodesFromCart = (cart) => {
    const codes = new Set();

    (cart?.discount_codes || []).forEach((entry) => {
      const code = typeof entry === 'string' ? entry : entry?.code;
      if (code) codes.add(String(code));
    });

    (cart?.cart_level_discount_applications || []).forEach((application) => collectDiscountName(codes, application));
    (cart?.discount_applications || []).forEach((application) => collectDiscountName(codes, application));
    (cart?.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((allocation) => collectDiscountName(codes, allocation.discount_application));
    });

    return Array.from(codes);
  };

  const allDiscountNames = (cart) => {
    const names = new Set(discountCodesFromCart(cart).map((value) => String(value).toUpperCase()));
    const addApplication = (application) => {
      if (application?.title) names.add(String(application.title).toUpperCase());
      if (application?.code) names.add(String(application.code).toUpperCase());
    };

    (cart?.cart_level_discount_applications || []).forEach(addApplication);
    (cart?.discount_applications || []).forEach(addApplication);
    (cart?.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((allocation) => addApplication(allocation?.discount_application));
    });
    return names;
  };

  const cartHasPackageCode = (cart) => {
    const names = allDiscountNames(cart);
    return names.has(DISCOUNT_CODE.toUpperCase()) || names.has(DISCOUNT_TITLE.toUpperCase());
  };

  const cartHasLegacyCode = (cart) => {
    const names = allDiscountNames(cart);
    return Array.from(LEGACY_CODES).some((code) => names.has(code.toUpperCase())) ||
      Array.from(LEGACY_TITLES).some((title) => names.has(title));
  };

  const isManagedCode = (value) => {
    const upper = String(value || '').toUpperCase();
    return upper === DISCOUNT_CODE.toUpperCase() ||
      upper === DISCOUNT_TITLE.toUpperCase() ||
      Array.from(LEGACY_CODES).some((code) => upper === code.toUpperCase()) ||
      LEGACY_TITLES.has(upper);
  };

  const hasRegularFlyX = (cart) => (cart?.items || []).some((item) => {
    if (!ELIGIBLE_SKATE_IDS.has(Number(item?.product_id || 0))) return false;
    const properties = item?.properties || {};
    return properties['Steel choice'] === 'BAUER FLY-X' &&
      properties['Steel package'] === 'Included with regular skate package';
  });

  const fetchCart = async () => {
    const response = await fetch(`${rootUrl()}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error('Could not read cart');
    return response.json();
  };

  const updateDiscountCodes = async (codes, cartDrawer) => {
    const payload = { discount: codes.join(',') };
    if (cartDrawer?.getSectionsToRender) {
      payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }

    const response = await fetch(`${rootUrl()}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    });
    const cart = await response.json();
    if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'Could not update cart discount');
    return cart;
  };

  const flyXDiscountRoute = () =>
    `${rootUrl()}discount/${encodeURIComponent(DISCOUNT_CODE)}?redirect=${encodeURIComponent(`${rootUrl()}cart`)}`;

  const applyDiscount = async ({ cartDrawer = document.querySelector('cart-drawer'), allowRedirect = false } = {}) => {
    const current = await fetchCart();
    const codes = discountCodesFromCart(current).filter((code) => !isManagedCode(code));
    codes.push(DISCOUNT_CODE);

    const updated = await updateDiscountCodes(codes, cartDrawer);
    if (cartHasPackageCode(updated)) return { applied: true, cart: updated, redirecting: false };

    const verified = await fetchCart();
    if (cartHasPackageCode(verified)) return { applied: true, cart: verified, redirecting: false };

    if (allowRedirect) {
      window.location.assign(flyXDiscountRoute());
      return { applied: false, cart: verified, redirecting: true };
    }

    return { applied: false, cart: verified, redirecting: false };
  };

  const removeDiscount = async (cartDrawer = document.querySelector('cart-drawer')) => {
    const current = await fetchCart();
    if (!cartHasPackageCode(current) && !cartHasLegacyCode(current)) return current;
    const codes = discountCodesFromCart(current).filter((code) => !isManagedCode(code));
    return updateDiscountCodes(codes, cartDrawer);
  };

  const syncDiscount = async () => {
    if (discountSyncPromise) return discountSyncPromise;

    discountSyncPromise = (async () => {
      const cart = await fetchCart();
      const shouldApply = hasRegularFlyX(cart);
      const hasPackage = cartHasPackageCode(cart);
      const hasLegacy = cartHasLegacyCode(cart);

      let updated = cart;
      if (shouldApply && (!hasPackage || hasLegacy)) {
        const result = await applyDiscount({ allowRedirect: false });
        updated = result.cart || cart;
      } else if (!shouldApply && (hasPackage || hasLegacy)) {
        updated = await removeDiscount();
      } else {
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: updated });
      } else if (cartDrawer && updated?.sections) {
        cartDrawer.renderContents?.(updated);
      }
    })()
      .catch((error) => console.error('SportsZone FLY-X savings error', error))
      .finally(() => { discountSyncPromise = null; });

    return discountSyncPromise;
  };

  const propertiesFromForm = (form) => {
    const properties = {};
    form.querySelectorAll('input[name^="properties["]').forEach((input) => {
      const match = input.name.match(/^properties\[(.+)\]$/);
      if (!match || !input.value) return;
      properties[match[1]] = input.value;
    });
    return properties;
  };

  const handleRegularFlyXSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const productForm = form.closest('product-form');
    const root = productForm?.closest('product-info');
    const card = root?.querySelector(CARD_SELECTOR);
    if (!productForm || !root || !card) return;

    const isSale = card.dataset.szSaleState === 'true' || card.classList.contains('is-boot-only-sale');
    const steel = card.querySelector('[data-sz-steel-input]:checked')?.value || '';
    const addon = root.querySelector('[data-sz-service-addon]:checked');

    // Sale skates and orders with a service add-on are handled by the main SportsZone configurator.
    if (isSale || steel !== 'FLY-X' || addon) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitButton = productForm.querySelector('[type="submit"]');
    if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

    const variantId = numericId(form.querySelector('input[name="id"]')?.value);
    const quantityInput = form.querySelector('input[name="quantity"]') || root.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    if (!variantId) {
      productForm.handleErrorMessage?.('Please choose a valid skate size and fit before adding to cart.');
      return;
    }

    const properties = propertiesFromForm(form);
    properties['Steel choice'] = 'BAUER FLY-X';
    properties['Steel package'] = 'Included with regular skate package';

    productForm.handleErrorMessage?.();
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    const spinner = productForm.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');

    const cartDrawer = document.querySelector('cart-drawer');
    const payload = { items: [{ id: variantId, quantity, properties }] };
    if (cartDrawer?.getSectionsToRender) {
      payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      cartDrawer.setActiveElement?.(document.activeElement);
    }

    try {
      const addResponse = await fetch(window.routes?.cart_add_url || routes.cart_add_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const addData = await addResponse.json();
      if (!addResponse.ok || addData.status) {
        productForm.handleErrorMessage?.(addData.description || addData.message || 'We could not add these skates to cart.');
        return;
      }

      const discountResult = await applyDiscount({ cartDrawer, allowRedirect: true });
      if (discountResult.redirecting) return;

      if (!discountResult.applied) {
        productForm.handleErrorMessage?.('The FLY-X package price adjustment could not be verified. Please try again before checkout.');
        return;
      }

      const cartData = discountResult.cart || addData;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: SOURCE,
          productVariantId: variantId,
          cartData,
        });
      }

      if (cartDrawer && cartData.sections) {
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(cartData);
      } else {
        window.location = window.routes?.cart_url || routes.cart_url;
      }
    } catch (error) {
      console.error('SportsZone FLY-X cart error', error);
      productForm.handleErrorMessage?.('We could not apply the FLY-X package price. Please try again.');
    } finally {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.('product-info').forEach((root) => scheduleUiSync(root));
  };

  document.addEventListener('change', (event) => {
    const root = event.target.closest?.('product-info');
    if (!root?.querySelector(CARD_SELECTOR)) return;

    if (event.target.matches?.('[data-sz-steel-input], variant-radios input[type="radio"], variant-selects select, variant-selects input[type="radio"]')) {
      scheduleUiSync(root);
    }
  });

  document.addEventListener('submit', handleRegularFlyXSubmit, true);
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === SOURCE) return;
      window.setTimeout(syncDiscount, 10);
    });
  }

  window.SportsZoneFlyXSavings = {
    applyDiscount,
    syncDiscount,
    cartHasPackageCode,
    code: DISCOUNT_CODE,
  };

  init();
  window.setTimeout(() => init(), 180);
  window.setTimeout(syncDiscount, 350);
})();
